import { render, staticRenderFns } from "./OrderNxKaipiao.vue?vue&type=template&id=5dd38bd2&scoped=true"
import script from "./OrderNxKaipiao.vue?vue&type=script&lang=js"
export * from "./OrderNxKaipiao.vue?vue&type=script&lang=js"
import style0 from "./OrderNxKaipiao.vue?vue&type=style&index=0&id=5dd38bd2&prod&scoped=true&lang=css"
import style1 from "./OrderNxKaipiao.vue?vue&type=style&index=1&id=5dd38bd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd38bd2",
  null
  
)

export default component.exports